import { LifeBuoyIcon, TicketIcon } from 'lucide-react'
import type { ReactNode } from 'react'

import { cn } from '@/utils'
import type { HelpView } from '../store'

interface HelpViewTabsProps {
  view: HelpView
  onSelect: (view: HelpView) => void
  unreadCount: number
}

const ViewTab = ({
  active,
  onClick,
  children,
}: {
  active: boolean
  onClick: () => void
  children: ReactNode
}) => (
  <button
    type="button"
    onClick={onClick}
    aria-current={active ? 'page' : undefined}
    className={cn(
      'flex cursor-pointer items-center gap-2 rounded-lg px-4 py-2 text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
      active
        ? 'bg-white text-brand-deep shadow-sm'
        : 'text-ink-subtle hover:text-blue-7',
    )}
  >
    {children}
  </button>
)

export const HelpViewTabs = ({
  view,
  onSelect,
  unreadCount,
}: HelpViewTabsProps) => (
  <nav
    aria-label="Help sections"
    className="inline-flex items-center gap-1 rounded-xl bg-blue-2/70 p-1"
  >
    <ViewTab active={view === 'help'} onClick={() => onSelect('help')}>
      <LifeBuoyIcon className="size-4" />
      Get help
    </ViewTab>

    <ViewTab active={view === 'tickets'} onClick={() => onSelect('tickets')}>
      <TicketIcon className="size-4" />
      My tickets
      {unreadCount > 0 && (
        <span className="inline-flex h-5 min-w-5 items-center justify-center rounded-full bg-brand-deep px-1.5 text-xs font-semibold text-white">
          {unreadCount}
        </span>
      )}
    </ViewTab>
  </nav>
)
